
import { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { Grid, useTheme } from '@mui/material';
import { useAuthStore } from '../../../stores';
import { CardDetalles } from '../../components';
import { LayoutCrearDoc } from '../../layouts';




export const DashboardCliene = () => {


    const theme = useTheme();
    const navigate = useNavigate();
    const { startLogoutCliente } = useAuthStore();


    const handleLogout = () => {
        startLogoutCliente();
        navigate('/');
    }



    const CARDS_CONFIG = [
        {
            key: '1', title: "Tus Pedidos",
            description: "Mira y rastrea tus pedidos o compra algo de nuevo.",
            icon: 'pedidos', route: '/mis-pedidos',
            funcion: null, color:'#9C27B0',
        },
        // {
        //     key: '2', title: "Tus Pagos",
        //     description: "Ver todas las transacciones y métodos de pagos.",
        //     icon: 'abono', route: '',
        //     funcion: null, color: '#9C27B0',
        // },
        {
            key: '3', title: "Perfil",
            description: "Administrar, agregar o eliminar datos para una mejor experiencia.",
            icon: 'micuenta', route: '/perfil',
            funcion: null, color: '#4CAF50'
        },
        // {
        //     key: '4', title: "Tus Mensajes",
        //     description: "Ver mensajes de la empresa para un mejor servicio.",
        //     icon: 'mensaje', route: '',
        //     funcion: null, color: '#FF9800'
        // },
        // {
        //     key: '5', title: "Pedidos Archivados",
        //     description: "Ver y administrar tus pedidos archivados.",
        //     icon: 'archivado', route: '',
        //     funcion: null, color: '#9C27B0'
        // },
        // {
        //     key: '6', title: "Carnet de Usuario",
        //     description: "Esta tarjeta es útil para identificar usuarios, permitiendo descargarla.",
        //     icon: 'carnet', route: '/super/micarnet',
        //     funcion: null, color: '#00897B'
        // },
        {
            key: '7', title: "Seguridad de Cuenta",
            description: "Cambia tu contraseña periódicamente para mejor seguridad.",
            icon: 'seguridad', route: '/cambio-password',
            funcion: null, color: '#F44336'
        },
        { 
            title:"Logout", funcion: handleLogout,
            description:"Salir de tu cuenta con seguridad.",
            icon:'salida', route: null, 
            color: '#F44336', 
            key:'10'
        },
    ];


    const cards = useMemo(() => CARDS_CONFIG, []);


    return (

        <LayoutCrearDoc titulo='Mi Cuenta' add={false} pt={4} px={5}>
            <Grid container spacing={3} display="flex" justifyContent="flex-start" mt={3}>
                {cards.map((item) => (
                    <CardDetalles item={item} key={item.key} />
                ))}
            </Grid>
        </LayoutCrearDoc>



        //         <Grid item xs={12} sm={6} md={4} lg={3} >
        //             <Card >
        //                 <CardActionArea sx={{ height: 150, display: 'flex', justifyContent:'space-evenly' }} >

        //                     <Box pl={2}>
        //                         <Avatar sx={{ width: 65, height: 65 }}>
        //                             <PaidIcon sx={{ fontSize:40 }} />
        //                         </Avatar>
        //                     </Box>
        //                     <CardContent sx={{ textAlign:'center' }}>
        //                         <Typography variant='h5' component="div" sx={{ fontSize:20 }}>
        //                             Tus Pagos
        //                         </Typography>
        //                         <Typography variant="body2" color="text.secondary">
        //                             Ver todas las transacciones y metodos de pagos.
        //                         </Typography>
        //                     </CardContent>
        //                 </CardActionArea>
        //             </Card>
        //         </Grid>



        //         <Grid item xs={12} sm={6} md={4} lg={3}>
        //             <Card onClick={ () => redirecPage('mis-archivados') }>
        //                 <CardActionArea sx={{ height: 150, display: 'flex', justifyContent:'space-evenly' }} >
        //                     <Box pl={2}>
        //                         <Avatar sx={{ width: 65, height: 65 }}>
        //                             <PersonPinIcon sx={{ fontSize:40 }} />
        //                         </Avatar>
        //                     </Box>
        //                     <CardContent sx={{ textAlign:'center' }}>
        //                         <Typography variant='h5' component="div" sx={{ fontSize:20 }}>
        //                             Pedidos Archivados
        //                         </Typography>
        //                         <Typography variant="body2" color="text.secondary">
        //                             Ver y administrar tus pedidos archivados.
        //                         </Typography>
        //                     </CardContent>
        //                 </CardActionArea>
        //             </Card>
        //         </Grid>


        //         <Grid item xs={12} sm={6} md={4} lg={3} >
        //             <Card onClick={ () => redirecPage('cambio-password') }>
        //                 <CardActionArea sx={{ height: 150, display: 'flex', justifyContent:'space-evenly' }} >
        //                     <Box pl={2}>
        //                         <Avatar sx={{ width: 65, height: 65 }}>
        //                             <CameraAltIcon sx={{ fontSize:40 }} />
        //                         </Avatar>
        //                     </Box>
        //                     <CardContent sx={{ textAlign:'center' }}>
        //                         <Typography variant='h5' component="div" sx={{ fontSize:20 }}>
        //                             Seguridad de Cuenta
        //                         </Typography>
        //                         <Typography variant="body2" color="text.secondary">
        //                             Cambia tu contraseña periodicamente para mejor seguridad.
        //                         </Typography>
        //                     </CardContent>
        //                 </CardActionArea>
        //             </Card>
        //         </Grid>


    )
}
